import React from "react";
import { MapPin } from "lucide-react";
import { HERO_IMAGE } from "../mock";

const Hero = () => {
  return (
    <section id="home" className="relative pt-[68px]">
      <div className="relative h-[74vh] min-h-[520px] w-full overflow-hidden">
        <img
          src={HERO_IMAGE}
          alt="Munnar tea hills"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/10" />

        <div className="relative z-10 h-full max-w-7xl mx-auto px-5 md:px-8 flex items-center justify-center md:justify-end">
          <div className="relative">
            {/* teal accent squares */}
            <div className="absolute -top-8 -left-6 w-40 h-24 bg-[#25d3c4] hidden md:block" />
            <div className="absolute -bottom-8 -left-6 w-40 h-24 bg-[#25d3c4] hidden md:block" />
            <div className="relative bg-white shadow-2xl px-8 md:px-12 py-10 md:py-14 max-w-[520px]">
              <div className="flex items-center gap-2 text-neutral-700 text-xs tracking-[0.22em] font-semibold uppercase mb-5">
                <MapPin className="w-4 h-4 text-[#17a89b]" />
                Auracrest Haven
              </div>
              <h1 className="text-4xl md:text-6xl font-extrabold leading-[1.05] text-neutral-900">
                Your Luxury Retreat In Munnar
              </h1>
              <a
                href="#contact"
                className="inline-flex mt-8 items-center bg-[#17a89b] hover:bg-[#128a7f] text-white font-semibold px-7 py-3 rounded-md transition-colors"
              >
                Book Your Stay
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
